// Check if the user agent string contains "iPad" or "Android" and "tablet"
const isTabletByUserAgent = /(tablet|ipad|android)/i.test(navigator.userAgent);

// Check the screen size using window.matchMedia
const isTabletByScreenSize = window.matchMedia("(max-width: 768px)").matches;

export const isTablet = isTabletByUserAgent || isTabletByScreenSize;
